import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import i18n from './i18n'

import './styles/main.css';
import ThentiH1 from './components/ui_blocks/ThentiH1.vue';
import ThentiH2 from './components/ui_blocks/ThentiH2.vue';

const app = createApp(App);
const pinia = createPinia();

app.use(router);
app.use(pinia);
app.use(i18n);

app.component('ThentiH1', ThentiH1)
app.component('ThentiH2', ThentiH2)

app.mount('#app');
